import { Navigate, Outlet } from 'react-router';
import { useIsAdministrator } from '@/hooks/useIsAdministrator';
import { PageSpinner } from '@/components/PageSpinner';

/**
 * Replaces AdminGuard. This only controls what the app renders. The real
 * boundary is the CloudFront signed cookie on /admin/* plus whatever the API
 * enforces; do not treat this as a security control.
 */
export function RequireAdmin() {
  const { isAdmin, isPending } = useIsAdministrator();

  if (isPending) return <PageSpinner message="Checking permissions..." />;
  if (!isAdmin) return <Navigate to="/home" replace />;

  return <Outlet />;
}
